import { pgTable, text, timestamp, integer, index } from 'drizzle-orm/pg-core';
import { sql } from 'drizzle-orm';
import { emailDeliverySource } from './enums';

/**
 * EmailDelivery — единый журнал исходящих писем и трекинга открытий.
 *
 * Создаётся EmailSenderService при каждой отправке (когда передан tracking).
 * Источник идентифицирует, к какой сущности относится письмо
 * (см. emailDeliverySource), sourceId — внешний ключ в соответствующей таблице
 * (UserInvitation.id, BroadcastDelivery.id, TriggerLog.id, Order.id и т.д.).
 * Без FK constraints — источники полиморфные и могут удаляться.
 *
 * Открытие письма фиксируется публичным эндпоинтом GET /api/email/track/:token,
 * который инкрементит openCount и обновляет firstOpenedAt/lastOpenedAt.
 * При первом открытии денормализованные поля синхронизируются на источнике
 * (UserInvitation.emailFirstOpenedAt, BroadcastDelivery.firstOpenedAt и т.д.).
 */
export const emailDelivery = pgTable(
  'EmailDelivery',
  {
    id: integer().primaryKey().generatedAlwaysAsIdentity(),
    source: emailDeliverySource().notNull(),
    sourceId: integer(),
    userId: integer(),
    recipientEmail: text().notNull(),
    subject: text(),
    sentAt: timestamp({ precision: 3, mode: 'date' })
      .default(sql`CURRENT_TIMESTAMP`)
      .notNull(),
    firstOpenedAt: timestamp({ precision: 3, mode: 'date' }),
    lastOpenedAt: timestamp({ precision: 3, mode: 'date' }),
    openCount: integer().default(0).notNull(),
    userAgentFirst: text(),
    ipFirst: text(),
  },
  (table) => [
    index('EmailDelivery_source_sourceId_idx').using(
      'btree',
      table.source.asc().nullsLast(),
      table.sourceId.asc().nullsLast(),
    ),
    index('EmailDelivery_userId_idx').using('btree', table.userId.asc().nullsLast()),
    index('EmailDelivery_sentAt_idx').using('btree', table.sentAt.asc().nullsLast()),
    index('EmailDelivery_recipientEmail_idx').using(
      'btree',
      table.recipientEmail.asc().nullsLast(),
    ),
  ],
);
